module.exports = __webpack_public_path__ + "img/Icon material-edit.dc257775.svg";